import { getAuthHeaders } from "../api/client";

export function parseAuthFailure(data) {
  const detail = data && data.detail;
  if (detail && typeof detail === "object") {
    return {
      code: detail.code || "",
      message: typeof detail.message === "string" ? detail.message : "",
    };
  }
  if (typeof detail === "string") return { code: "", message: detail };
  if (data && typeof data.message === "string") return { code: "", message: data.message };
  return { code: "", message: "" };
}

export function mapOpsAuthError(err, lang, fallbackEn, fallbackGr) {
  const raw = err && err.message ? String(err.message) : "";
  const lower = raw.toLowerCase();
  const code = err && err.code ? String(err.code) : "";
  if (code === "ACCOUNT_PENDING" || lower.includes("waiting for administrator") || lower.includes("account_pending")) {
    return lang === "gr"
      ? "Ο λογαριασμός περιμένει έγκριση διαχειριστή."
      : "Your account is waiting for administrator approval.";
  }
  if (code === "ACCOUNT_DEACTIVATED" || lower.includes("deactivated")) {
    return lang === "gr" ? "Ο λογαριασμός είναι απενεργοποιημένος." : "This account is deactivated.";
  }
  if (code === "USE_GOOGLE" || lower.includes("must sign in with google") || lower.includes("signs in with google")) {
    return lang === "gr"
      ? "Οι λογαριασμοί @stiq.gr συνδέονται με Google."
      : "@stiq.gr accounts must sign in with Google.";
  }
  if (code === "NO_ACCESS_THIS_APP" || lower.includes("no access to stiq ops")) {
    return lang === "gr"
      ? "Δεν έχετε πρόσβαση στο Stiq Ops. Ζητήστε έγκριση από διαχειριστή."
      : "No access to Stiq Ops. Ask an administrator to grant Ops modules.";
  }
  if (code === "EMAIL_EXISTS" || lower.includes("already exists")) {
    return lang === "gr" ? "Υπάρχει ήδη λογαριασμός με αυτό το email." : "An account with this email already exists.";
  }
  if (code === "RATE_LIMITED" || code === "PENDING_QUEUE_FULL" || lower.includes("too many")) {
    return lang === "gr"
      ? "Πολλές προσπάθειες. Δοκιμάστε ξανά σε λίγο."
      : "Too many attempts. Try again later.";
  }
  if (code === "INVALID_RESET" || lower.includes("reset link")) {
    return lang === "gr"
      ? "Ο σύνδεσμος επαναφοράς δεν ισχύει ή έχει λήξει."
      : "This reset link is invalid or has expired.";
  }
  if (raw) return raw;
  return lang === "gr" ? fallbackGr : fallbackEn;
}

export function throwAuthFailure(data, fallback) {
  const parsed = parseAuthFailure(data);
  const err = new Error(parsed.message || fallback);
  err.code = parsed.code;
  throw err;
}

export function getAuthHeadersMultipart() {
  const headers = getAuthHeaders();
  const authorization = headers.Authorization;
  if (!authorization || typeof authorization !== "string") {
    return {};
  }
  const trimmed = authorization.trim();
  if (!trimmed) {
    return {};
  }
  return { Authorization: trimmed };
}